module.exports = __webpack_public_path__ + "img/電気回路_4_2_1.7ee61c7b.png";